<template>
    <div class="vue-filter-wrapper filter col-12" :class="open ? 'open' : 'closed'">
        <h3 v-if="title" @click="open = ! open" class="virtual-p font-weight-bold">{{ title }}</h3>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "OccasionFilterGroup",

    props: ['title', 'showOpen'],

    data() {
        return {
            open: false,
        }
    },

    mounted() {
        if (this.showOpen === true) {
            this.open = true;
        }
    }
}
</script>
